import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Divider from '@Components/Divider/Divider';
import RadioButton from '@Components/controls/RadioButton/RadioButton';
import ConditionalRender from '@Components/ConditionalRender/ConditionalRender';
import useTranslate from '@Utils/hooks/useTranslate';
import { setOutletPickupFocus } from '@Redux/modules/addressBook/actions';
import FilterAddresses from './FilterAddresses';
import { SelectedAddressType } from '../ShippingMethod';
import { RadioButtonWrapper } from './../ShippingMethod.styled';
import useAddressBook from '@Utils/hooks/useAddressBook';

interface IAddressOptions {
	addressType: SelectedAddressType;
	differentAddress: () => JSX.Element;
	isPrepaidPurchase: boolean | undefined;
	setAddressType: (type: SelectedAddressType) => void;
}

const AddressOptions = ({
	addressType,
	differentAddress,
	isPrepaidPurchase,
	setAddressType,
}: IAddressOptions): JSX.Element => {
	const { translate } = useTranslate();
	const dispatch = useDispatch();
	const isLogged = useSelector((state: types.redux.IState) => state.api.authentication.signedIn);
	const { addressBook } = useAddressBook();

	const renderRadioButton = (labelKey: string, type: SelectedAddressType) => (
		<RadioButton
			label={translate(labelKey)}
			selected={addressType}
			onClick={() => {
				setAddressType(type);
				dispatch(setOutletPickupFocus({ outletPickupFocus: false }));
			}}
			name="radio"
			value={type}
			marginRight={16}
		/>
	);

	const radioDifferent = () =>
		renderRadioButton('shipping-method.address-type.diffrent', SelectedAddressType.DIFFERENT);

	const radioAddressBook = () =>
		renderRadioButton('shipping-method.select.from.address.book', SelectedAddressType.ADRESS_BOOK);

	return (
		<>
			<RadioButtonWrapper>
				<ConditionalRender
					show={!!isLogged}
					onTrue={() => (
						<>
							{radioAddressBook()}
							<Divider withoutLine marginBottom={18} />
						</>
					)}
				/>
				{addressType === SelectedAddressType.ADRESS_BOOK && (
					<FilterAddresses
						addressBook={addressBook}
						addressType={addressType}
						filter={undefined}
						isPrepaidPurchase={isPrepaidPurchase}
					/>
				)}
				<ConditionalRender show={!!isLogged} onTrue={() => <>{radioDifferent()}</>} />
			</RadioButtonWrapper>
			<ConditionalRender show={addressType === SelectedAddressType.DIFFERENT} onTrue={() => differentAddress()} />
		</>
	);
};

export default AddressOptions;
